import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'product_tile-hide_brand-submit';
/**
 * Event is fired when retailer chooses to hide a band from a product tile (modal completed)
 */
export function trackProductTileHideBrandSubmit(request_id, brandToken, productToken, position2, reason3, impression_id4) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
        parameters: {
            request_id,
            brandToken,
            productToken,
            position2,
            reason3,
            impression_id4,
        },
    });
}
